const NavigationRoutes = {
  Login_Screen: '/login',
  Forgot_Screen: '/auth/forgot',
  Password_Screen: '/auth/password',
  Otp_Screen: '/auth/otp',
  Home_Screen: '/',
  User_Settings_Screen: '/user/settings',
  Branch_Screen: '/branch',
  User_ListScreen: '/user',
  Brand_ListScreen: '/brand',
  Valuation_ListScreen: '/valuation/list',

  Model_ListScreen: '/model',
  Option_ListScreen: '/option',
  ValuationScreen: '/valuation/:type',
  ValuationEditScreen: '/valuation/edit/:id',
  User_Password_ChangeScreen: '/user/password-change',
  Permission_listScreen: '/permission/list',

  Valuation_Task_Screen: '/valuation/task',
  Task_Report_Screen: '/task/report',

  Settings_Screen: '/settings',
  Settings_VehiclesNotPledged_Screen: '/settings/vehiclesNotPledged',
  Settings_NoneCollateralVehicle_Screen: '/settings/noneCollateralVehicle',
  AppraisalSendValuationScreen: '/sendvaluation/:id',
};

export { NavigationRoutes };
